// extracted by mini-css-extract-plugin
module.exports = {"FooterMiddle":"FooterMiddle_FooterMiddle__qHUJ0","FooterMiddle__lists":"FooterMiddle_FooterMiddle__lists__fhJnD","FooterMiddle__list":"FooterMiddle_FooterMiddle__list__I6pan"};